import { Config, Receiver, Shipper, Customs, Payment, Package, Promocode, SessionState } from './reducers'
import { BasketShipment } from '../reducers'

export const ACTION = {
  INITIALIZE_BASKET: 'INITIALIZE_BASKET@basket/session',
  CLEAR_BASKET: 'CLEAR_BASKET@basket/session',
  PREFILL_AFTER_FAILED_PAYMENT: 'PREFILL_AFTER_FAILED_PAYMENT@basket/session',
  UPDATE_BASKET_CONFIG: 'UPDATE_BASKET_CONFIG@basket/session',
  UPDATE_PACKAGE: 'UPDATE_PACKAGE@basket/session',
  ADD_SHIPMENT: 'ADD_SHIPMENT@basket/session',
  REMOVE_SHIPMENT: 'REMOVE_SHIPMENT@basket/session',
  SELECT_SHIPMENT: 'SELECT_SHIPMENT@basket/session',
  CONFIRM_STEP: 'CONFIRM_STEP@basket/session',
  UPDATE_RECEIVER: 'UPDATE_RECEIVER@basket/session',
  UPDATE_SHIPPER: 'UPDATE_SHIPPER@basket/session',
  UPDATE_CUSTOMS: 'UPDATE_CUSTOMS@basket/session',
  UPDATE_PAYMENT: 'UPDATE_PAYMENT@basket/session',
  UPDATE_PROMOCODE: 'UPDATE_PROMOCODE@basket/session',
  DELETE_PROMOCODE: 'DELETE_PROMOCODE@basket/session',
  ADD_PROMOCODE: 'ADD_PROMOCODE@basket/session',
  ORDER_SUBMITTED: 'ORDER_SUBMITTED@basket/session',
  ORDER_COMPLETED: 'ORDER_COMPLETED@basket/session',
  ORDER_FAILED: 'ORDER_FAILED@basket/session',
  FETCH_MKT_PREFERENCE: 'FETCH_MKT_PREFERENCE@basket/session',
  FETCH_MKT_PREFERENCE_SUCCESS: 'FETCH_MKT_PREFERENCE_SUCCESS@basket/session',
  FETCH_MKT_PREFERENCE_FAILURE: 'FETCH_MKT_PREFERENCE_FAILURE@basket/session',
  PAYMENT_PROVIDER_RESULT: 'PAYMENT_PROVIDER_RESULT@basket/session',
} as const

export type InitializeBasketAction = {
  type: typeof ACTION.INITIALIZE_BASKET
  payload: {
    originCountry: string
    config: Partial<Config>
  }
}

export const initializeBasket = (originCountry: string, config: Partial<Config>): InitializeBasketAction => ({
  type: ACTION.INITIALIZE_BASKET,
  payload: {
    config,
    originCountry,
  },
})

export type ClearBasketAction = {
  type: typeof ACTION.CLEAR_BASKET
}

export const clearBasket = (): ClearBasketAction => ({
  type: ACTION.CLEAR_BASKET,
})

export type PrefillAfterFailedPaymentAction = {
  type: typeof ACTION.PREFILL_AFTER_FAILED_PAYMENT
  payload: SessionState
}

export const prefillBasketSessionAfterFailedPayment = (
  sessionState: SessionState
): PrefillAfterFailedPaymentAction => ({
  type: ACTION.PREFILL_AFTER_FAILED_PAYMENT,
  payload: {
    ...sessionState,
  },
})

export type AddShipmentAction = {
  type: typeof ACTION.ADD_SHIPMENT
  payload: {
    weight: number | null
  }
}

export const addShipment = (weight: number | null = null): AddShipmentAction => ({
  type: ACTION.ADD_SHIPMENT,
  payload: {
    weight,
  },
})

export type RemoveShipmentAction = {
  type: typeof ACTION.REMOVE_SHIPMENT
  payload: {
    shipmentId: number
  }
}

export const removeShipment = (shipmentId: number): RemoveShipmentAction => ({
  type: ACTION.REMOVE_SHIPMENT,
  payload: {
    shipmentId,
  },
})

export type SelectShipmentAction = {
  type: typeof ACTION.SELECT_SHIPMENT
  payload: {
    shipmentId: number
  }
}

export const selectShipment = (shipmentId: number): SelectShipmentAction => ({
  type: ACTION.SELECT_SHIPMENT,
  payload: {
    shipmentId,
  },
})

export type UpdateBasketConfigAction = {
  type: typeof ACTION.UPDATE_BASKET_CONFIG
  payload: {
    config: Partial<Config>
  }
}

export const updateBasketConfig = (config: Partial<Config>): UpdateBasketConfigAction => ({
  type: ACTION.UPDATE_BASKET_CONFIG,
  payload: {
    config,
  },
})

export type UpdatePackageOptions = {
  hasUpdatedDestinationCountry?: boolean
  hasUpdatedCarrierKey?: boolean
  hasUpdatedParcelTypeKey?: boolean
}

export type UpdatePackageAction = {
  type: typeof ACTION.UPDATE_PACKAGE
  payload: {
    package: Partial<Package>
    options: UpdatePackageOptions
  }
}

export const updatePackage = ($package: Partial<Package>, options: UpdatePackageOptions = {}): UpdatePackageAction => ({
  type: ACTION.UPDATE_PACKAGE,
  payload: {
    package: $package,
    options,
  },
})

export type ConfirmStepAction = {
  type: typeof ACTION.CONFIRM_STEP
  payload: {
    stepName: string
  }
}

export const confirmStep = (stepName: string): ConfirmStepAction => ({
  type: ACTION.CONFIRM_STEP,
  payload: {
    stepName,
  },
})

export type UpdateReceiverOptions = {
  hasUpdatedCity?: boolean
  hasUpdatedPostalCode?: boolean
  hasUpdatedDeliveryOptionKey?: boolean
  hasUpdatedServiceOptionKeys?: boolean
  hasUpdatedInsuranceValue?: boolean
}

export type UpdateReceiverAction = {
  type: typeof ACTION.UPDATE_RECEIVER
  payload: {
    receiver: Partial<Receiver>
    options: UpdateReceiverOptions
  }
}

export const updateReceiver = (
  receiver: Partial<Receiver>,
  options: UpdateReceiverOptions = {}
): UpdateReceiverAction => ({
  type: ACTION.UPDATE_RECEIVER,
  payload: {
    receiver,
    options,
  },
})

export type UpdateShipperOptions = {
  hasUpdatedPostalCode?: boolean
}

export type UpdateShipperAction = {
  type: typeof ACTION.UPDATE_SHIPPER
  payload: {
    shipper: Shipper
    options: UpdateShipperOptions
  }
}

export const updateShipper = (shipper: Shipper, options: UpdateShipperOptions = {}): UpdateShipperAction => ({
  type: ACTION.UPDATE_SHIPPER,
  payload: {
    shipper,
    options,
  },
})

export type UpdateCustomsAction = {
  type: typeof ACTION.UPDATE_CUSTOMS
  payload: {
    customs: Customs
  }
}

export const updateCustoms = (customs: Customs): UpdateCustomsAction => ({
  type: ACTION.UPDATE_CUSTOMS,
  payload: {
    customs,
  },
})

export type UpdatePaymentOptions = {
  hasUpdatedCaptcha?: boolean
  hasUpdatedPaymentType?: boolean
  hasUpdatedPromocode?: boolean
}

export type UpdatePaymentAction = {
  type: typeof ACTION.UPDATE_PAYMENT
  payload: {
    payment: Partial<Payment>
    options: UpdatePaymentOptions
  }
}

export const updatePayment = (payment: Partial<Payment>, options: UpdatePaymentOptions): UpdatePaymentAction => ({
  type: ACTION.UPDATE_PAYMENT,
  payload: {
    payment,
    options,
  },
})

export type UpdatePromocodeAction = {
  type: typeof ACTION.UPDATE_PROMOCODE
  payload: {
    shipmentId: number
    promocode: Partial<Promocode>
  }
}

export type GetMarketingPreferenceAction = {
  type: typeof ACTION.FETCH_MKT_PREFERENCE
}

export type GetMarketingPreferenceSuccessAction = {
  type: typeof ACTION.FETCH_MKT_PREFERENCE_SUCCESS
  payload: {
    wantsNewsAndPromotions: boolean
  }
}

export type GetMarketingPreferenceFailureAction = {
  type: typeof ACTION.FETCH_MKT_PREFERENCE_FAILURE
  payload: {
    wantsNewsAndPromotions: boolean
  }
}

export const updatePromocode = (shipmentId: number, promocode: Partial<Promocode>): UpdatePromocodeAction => ({
  type: ACTION.UPDATE_PROMOCODE,
  payload: {
    shipmentId,
    promocode,
  },
})
export const fetchMarketingPreference = (): GetMarketingPreferenceAction => ({
  type: ACTION.FETCH_MKT_PREFERENCE,
})

export const saveMarketingPreferenceSuccess = (
  wantsNewsAndPromotions: boolean
): GetMarketingPreferenceSuccessAction => ({
  type: ACTION.FETCH_MKT_PREFERENCE_SUCCESS,
  payload: {
    wantsNewsAndPromotions,
  },
})

export const saveMarketingPreferenceFailure = (
  wantsNewsAndPromotions: boolean
): GetMarketingPreferenceFailureAction => ({
  type: ACTION.FETCH_MKT_PREFERENCE_FAILURE,
  payload: {
    wantsNewsAndPromotions,
  },
})

export type AddPromocodeAction = {
  type: typeof ACTION.ADD_PROMOCODE
  payload: {
    promocode: string
    shipmentId: number
    shipments: BasketShipment[]
  }
}

export const addPromocode = (promocode: string, shipmentId: number, shipments: BasketShipment[]) => ({
  type: ACTION.ADD_PROMOCODE,
  payload: {
    promocode,
    shipmentId,
    shipments,
  },
})

export type DeletePromocodeAction = {
  type: typeof ACTION.DELETE_PROMOCODE
  payload: {
    shipmentId: number
  }
}

export const deletePromocode = (shipmentId: number): DeletePromocodeAction => ({
  type: ACTION.DELETE_PROMOCODE,
  payload: {
    shipmentId,
  },
})

export type OrderSubmittedAction = {
  type: typeof ACTION.ORDER_SUBMITTED
}

export const orderSubmitted = (): OrderSubmittedAction => ({
  type: ACTION.ORDER_SUBMITTED,
})

export type OrderCompletedAction = {
  type: typeof ACTION.ORDER_COMPLETED
}

export const orderCompleted = (): OrderCompletedAction => ({
  type: ACTION.ORDER_COMPLETED,
})

export type OrderFailedAction = {
  type: typeof ACTION.ORDER_FAILED
}

export const orderFailed = (): OrderFailedAction => ({
  type: ACTION.ORDER_FAILED,
})

export type Action =
  | InitializeBasketAction
  | ClearBasketAction
  | PrefillAfterFailedPaymentAction
  | UpdateBasketConfigAction
  | UpdatePackageAction
  | AddShipmentAction
  | RemoveShipmentAction
  | SelectShipmentAction
  | ConfirmStepAction
  | UpdateReceiverAction
  | UpdateShipperAction
  | UpdateCustomsAction
  | AddPromocodeAction
  | UpdatePaymentAction
  | UpdatePromocodeAction
  | DeletePromocodeAction
  | OrderSubmittedAction
  | OrderCompletedAction
  | OrderFailedAction
  | GetMarketingPreferenceSuccessAction
  | GetMarketingPreferenceFailureAction
